import { css } from 'styled-components';
import { variableFontRegular } from 'styles/theme/text';

export const AccountDropdownMenuWrapper = css`
  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    background-color: ${({ theme }) => theme.navigation.backgroundColor};
    border: 1px solid ${({ theme }) => theme.navigation.borderColor};
    border-top: none;
    min-width: 175px;
    padding: 24px;
    text-align: right;
    ${variableFontRegular({ size: '11.5px' })};
  }
`;

export const AccountDropdownMenuList = css`
  ${variableFontRegular({ height: '12px' })};
  margin: 0px;

  > li {
    margin-bottom: 10px;
    cursor: pointer;

    &:active {
      text-decoration: underline;
    }

    @media (hover: hover) {
      &:hover {
        text-decoration: underline;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    align-items: flex-end;
    color: ${({ theme }) => theme.navigation.textColor};
    display: flex;
    flex-direction: column;
    ${variableFontRegular({ size: '11.5px' })};

    > li {
      margin-bottom: 8px;
    }
  }
`;

export const AccountDropdownMenuListItem = css`
  cursor: pointer;
  width: fit-content;
  list-style: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const AccountDropdownMenuButton = css`
  padding: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumLarge}px) {
    padding: 0;
  }

  &.logOutButton {
    padding-top: 18px;
  }

  &:hover {
    text-decoration: underline;
  }
`;
